import { ChangeDetectionStrategy, Component, input, output, signal, computed } from '@angular/core';
import { downgradeComponent } from '@angular/upgrade/static';
import App from '@app/app';
import { LtTranslatePipe } from '@app/pipes/lt-translate.pipe';
import { LtIconComponent } from '@app/components/core/lt-icon/lt-icon.component';

export interface SelectOption {
  value: string;
  label: string;
  translateLabel?: boolean;
}

@Component({
  selector: 'lt-select',
  templateUrl: './lt-select.component.html',
  styleUrl: './lt-select.component.scss',
  imports: [LtTranslatePipe, LtIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LtSelectComponent {
  testId = input.required<string>();
  label = input<string>('');
  value = input<string>('');
  options = input<SelectOption[]>([]);
  required = input<boolean>(false);
  disabled = input<boolean>(false);
  error = input<string | null>(null);
  placeholder = input<string>('');

  valueChange = output<string>();

  readonly selectId = `lt-select-${Math.random().toString(36).slice(2)}`;

  isFocused = signal(false);

  hasValue = computed(() => Boolean(this.value()));
  hasLabel = computed(() => Boolean(this.label()));
  hasError = computed(() => Boolean(this.error()));

  onChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    this.valueChange.emit(target.value);
  }

  onFocus(): void {
    this.isFocused.set(true);
  }

  onBlur(): void {
    this.isFocused.set(false);
  }
}

App.directive('ltSelect', downgradeComponent({ component: LtSelectComponent }));
